const isSSR = () => typeof window === "undefined";
export {
  isSSR
};
//# sourceMappingURL=ssrUtils.js.map
